<script setup lang="ts">
import {storeToRefs} from "pinia";
import {useEnvironment} from "~/stores/spaces";

const {workspaces} = storeToRefs(useSpacesStore())
const {
  workspaceId,
  workspace,
  environmentId,
} = useEnvironment()
const router = useRouter()

const workspaceSelectItems = computed(() => {
  return workspaces.value.map((w) => {
    return {
      title: w.name,
      value: w.identifier
    }
  }).sort((a, b) => {
    return a.title.localeCompare(b.title)
  })
})

const environmentSelectItems = computed(() => {
  if(!workspace.value) {
    return []
  }
  return workspace.value.environments.map((e) => {
    return {
      title: e.name,
      value: e.identifier
    }
  }).sort((a, b) => {
    return a.title.localeCompare(b.title)
  })
})

const updateWorkspace = (value: string) => {
  // We can't guess which one, so we will switch to the first environment ID, alphabetically
  const environment = workspaces.value.find((w) => w.identifier === value)?.environments.sort((a, b) => {
    return a.name.localeCompare(b.name)
  })[0]


  router.push(router.currentRoute.value.path.replace(workspaceId.value, value).replace(environmentId.value, environment.identifier))
}

const updateEnvironment = (value: string) => {
  router.push(router.currentRoute.value.path.replace(environmentId.value, value))
}
</script>

<template>
  <template v-if="workspaceId && environmentId">

    <v-select
        variant="plain"
        label="Workspace"
        hide-details
        :model-value="workspaceId"
        :items="workspaceSelectItems"
        @update:model-value="updateWorkspace"
        style="width: 200px;"
    />
    <v-select
        label="Environment"
        variant="plain"
        hide-details
        :model-value="environmentId"
        :items="environmentSelectItems"
        @update:model-value="updateEnvironment"
        style="width: 200px;"
    />
  </template>
</template>
